import moment from "moment";

export default function formatDateLocal(data, type) {
  const value =
    type === "datetime-local"
      ? moment.utc(data).format("yyyy-MM-DDTHH:mm")
      : type === "date"
      ? moment.utc(data).format("YYYY-MM-DD")
      : data;

  if (
    (type === "datetime-local" || type === "date") &&
    value.toString() !== "Invalid date"
  ) {
    return value;
  }

  return value;
}
